<template>
  <div>
    <!-- Spacer, conditionally rendered -->
<!--    <div v-if="hasBorderRadius" :class="$style.spacer"></div>-->
    <!-- Close button -->
    <div :class="[{ [$style.hasBackground]: hasBorderRadius }, $style.closeBtn, $style[widgetSide]]"
         :style="computedStyle"
         @click="$emit('close')">
      <i class="icon-miniX"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CloseButton',
  props: {
    closeButtonColor: {
      type: String,
      required: false,
      default: '',
    },
    hasBorderRadius: {
      type: Boolean,
      required: false,
      default: false,
    },
    widgetSide: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    computedStyle() {
      // Initial base style is for the closeButtonColor.
      let style = { color: this.closeButtonColor }

      if (this.hasBorderRadius && this.widgetSide === 'left') {
        style = { ...style, top: '28px', right: '5px' }
      } else if (this.hasBorderRadius && this.widgetSide === 'right') {
        style = { ...style, top: '28px', left: '5px' }
      } else if (!this.hasBorderRadius && this.widgetSide === 'right') {
        style = { ...style, top: '20px', left: '0' }
      } else if (!this.hasBorderRadius && this.widgetSide === 'left') {
        style = { ...style, top: '20px', right: '0' }
      }

      return style
    },
  },
}
</script>

<style lang="scss" module>
.closeBtn.closeBtn {
  position: absolute;
  z-index: 10;
  width: 25px;
  height: 25px;
  padding-left: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;

  i {
    font-size: 15px;
    line-height: 25px;
    color: inherit;
  }

  &:hover {
    opacity: 0.6;
  }
}

//.spacer {
//  height: 40px;
//}

.hasBackground.hasBackground {
  background-color: rgba(255, 255, 255, 0.6);
}
</style>